
import { defineComponent } from 'vue'
import RenderingRandselBody from '@/components/Rendering/options/RenderingRandselBody.vue'
import RenderingRandselEdge from '@/components/Rendering/options/RenderingRandselEdge.vue'
import RenderingRandselInside from '@/components/Rendering/options/RenderingRandselInside.vue'
import RenderingRandselFront from '@/components/Rendering/options/RenderingRandselFront.vue'
import RenderingRandselSide from '@/components/Rendering/options/RenderingRandselSide.vue'
import RenderingRandselPocket from '@/components/Rendering/options/RenderingRandselPocket.vue'
import RenderingRandselTack from '@/components/Rendering/options/RenderingRandselTack.vue'
import RenderingRandselBack from '@/components/Rendering/options/RenderingRandselBack.vue'
import RenderingRandselName from '@/components/Rendering/options/RenderingRandselName.vue'

export default defineComponent({
  name: 'RenderingRandselBag',
  components: {
    RenderingRandselBody,
    RenderingRandselEdge,
    RenderingRandselInside,
    RenderingRandselPocket,
    RenderingRandselSide,
    RenderingRandselFront,
    RenderingRandselTack,
    RenderingRandselBack,
    RenderingRandselName
  },
  props: {
    cameraPos: {
      type: Number,
      required: true
    },
    isPreview: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    return {}
  }
})
